"use client";

import ErrorScreen from "@/components/ui/error-screen";

export default ErrorScreen;
